import React from "react";
import { Helmet } from "react-helmet";

const BASE_URL = "https://tigerrefrigeratedtransport.com";

const defaultAlternates = [
  { hrefLang: "en-AE", href: `${BASE_URL}/` },
  { hrefLang: "ar-AE", href: `${BASE_URL}/` },
  { hrefLang: "x-default", href: `${BASE_URL}/` },
];

function Seo({
  title,
  description,
  path = "/",
  keywords = "",
  schema = null,
  image = `${BASE_URL}/assets/img/logo/logo-2.png`,
  type = "website",
  locale = "en_AE",
  alternates = defaultAlternates,
}) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const canonical = `${BASE_URL}${normalizedPath}`;
  const fullTitle = `${title} | Tiger Refrigerated Transport UAE`;

  return (
    <Helmet>
      <html lang="en-AE" dir="ltr" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />
      <meta name="author" content="Tiger Refrigerated Transport" />
      <meta name="language" content="English, Arabic" />
      <meta name="geo.region" content="AE" />
      <meta name="geo.placename" content="Abu Dhabi, Dubai, Sharjah, United Arab Emirates" />
      <meta name="distribution" content="global" />
      <link rel="canonical" href={canonical} />
      {alternates.map((alternate) => (
        <link
          key={`${normalizedPath}-${alternate.hrefLang}`}
          rel="alternate"
          hrefLang={alternate.hrefLang}
          href={alternate.href === `${BASE_URL}/` ? canonical : alternate.href}
        />
      ))}

      <meta property="og:type" content={type} />
      <meta property="og:locale" content={locale} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Tiger Refrigerated Transport" />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema ? (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      ) : null}
    </Helmet>
  );
}

export default Seo;
